var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.network)?_c('v-tooltip',{attrs:{"top":"","disabled":!_vm.tooltip},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"mx-1",attrs:{"small":"","icon":"","href":_vm.networkUrl,"target":"_blank"}},'v-btn',attrs,false),on),[_c('v-icon',{staticClass:"social-icon"},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1)]}}],null,false,83833629)},[_c('span',[_vm._v(_vm._s(_vm.tooltip))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }